import React from "react";

/*
    Account Icon
    props:
        - title: string, override the default title 'Account'
        - color: string, override the default color '#00549A' (bell blue)
*/

const AccountIcon = (props) => (
    <svg className={props.className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>{props.title || "Account"}</title>
        <path
            d="M18.2613 17.3722C19.5009 15.9288 20.25 14.0519 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 14.0519 4.49908 15.9288 5.73869 17.3722M18.2613 17.3722C16.7483 19.134 14.5045 20.25 12 20.25C9.49553 20.25 7.25172 19.134 5.73869 17.3722M18.2613 17.3722C18.2613 17.3722 14.6053 16.3421 14.1711 15.9079C13.7368 15.4737 13.7368 15.4737 13.7368 15.0395C13.7368 14.6053 15.0395 11.1316 15.0395 10.2632C15.0395 9.39474 15.0395 7.22368 12 7.22368C8.96053 7.22368 8.96053 9.39474 8.96053 10.2632C8.96053 11.1316 10.2632 14.6053 10.2632 15.0395C10.2632 15.4737 10.2632 15.4737 9.82895 15.9079C9.39474 16.3421 5.73869 17.3722 5.73869 17.3722"
            stroke={props.color || "#00549A"}
            strokeWidth="1.5"
        />
    </svg>
);

export default AccountIcon;
